import { deepTraverse } from 'es-sharp'

export default {
    methods: {
        exportToExcel({
            filename = "download", // 下载文件名
            offset = [0, 0], // 原点偏移量
            index, // 是否添加序号
            headers,
            rows,
            guide = [], // { r: 行号, c: 列号, rs: 跨行树, cs: 跨列树, v: 值, s: 样式设置}
            style = [], // style rules. [range]: {xss}
            indent = 4, // 树形表格，缩进空格数量
        } = {}) {
            rows = rows || this.exportRows()
            headers = headers || this.exportHeaders()

            // 序号列
            if (typeof index == "undefined") {
                index = headers.findIndex(v => v.type == "index") >= 0
            }

            // 过滤无效列
            headers = headers.filter(v => v.key || (v.children && v.children.length))

            // 添加序号列
            if (index) {
                headers.unshift({
                    title: "序号",
                    key: "$$index",
                    align: "center",
                    width: "60",
                })

                var count = 1
                deepTraverse(rows, (node) => {
                    node["$$index"] = count++
                })
            }

            // 异步加载导出库
            return import('xlsx-format-export/src/index')
                .then(res => {
                    return res.default({
                        filename,
                        offset,
                        guide,
                        headers,
                        rows,
                        style,
                        indent,
                    })
                })
                .then(result => {
                    window.xlsx = result
                    var { wb, headerRange } = result

                    // 设置表头样式
                    wb.sheet(0)
                        .range(headerRange.s.r + 1, headerRange.s.c + 1, headerRange.e.r + 1, headerRange.e.c + 1)
                        .style("fill", "f8f8f9")

                    return result.download()
                })
        },

        exportHeaders() {
            throw new Error("获取headers必需由子类实现")
        },

        exportRows() {
            throw new Error("获取rows必需由子类实现")
        },
    }
}